<template>
    <div>
        <!-- Dialogo card vinculado con acciones del dashboard-->
        <v-dialog v-model="isActive" transition="dialog-bottom-transition" scrollable persistent fullscreen
            class="ma-0 pa-0">
            <v-card class="rounded-0 ma-0 pa-0" v-if="origen == 'desktop'">
                <v-card elevation="0" height="58" class="ma-0 pa-0">
                    <v-app-bar flat height="58" color="white" dark class="rounded-0">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon light @click="confirmAndClose(true)">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <span>Cerrar</span>
                        </v-tooltip>
                        <v-toolbar-title class="font-weight-bold primary--text">Orden de pago</v-toolbar-title>
                    </v-app-bar>
                </v-card>
                <v-card flat width="100%" height="100%" class="ma-0 pa-0">
                    <iframe :src="urlMercadoPago" loading="lazy" scrolling="auto" height="100%" width="100%"
                        frameborder="0" ref="mpiframe" @load="onIframeLoad"></iframe>
                </v-card>
            </v-card>
            <v-card v-else class="d-flex flex-column align-center justify-center rounded-0 ma-0 pa-0">
                <v-card-text class="d-flex flex-column align-center justify-center">
                    <div class="font-weight-regular primary--text text-center text-h5 mb-0" v-html="mensaje"></div>
                    <div v-if="!esperaPago" class="d-flex flex-column align-center justify-center">
                        <!-- iOS: usamos un <a> HTML puro (NO v-btn) para que
                             Safari respete el Universal Link de la app de MP.
                             v-btn agrega listeners (ripple, focus, etc) que
                             interfieren y rompen la apertura de la app nativa. -->
                        <a v-if="esIOS" :href="urlMercadoPago || '#'" target="_self"
                            class="boton-mp-ios elevation-2 mb-5"
                            :class="{ 'boton-mp-ios--disabled': !urlMercadoPago }"
                            :style="{ 'min-width': ($vuetify.breakpoint.xsOnly) ? '280px' : '320px' }">
                            <MercadoPago />
                            <span class="ml-1">Pagar con Mercado Pago</span>
                        </a>
                        <v-btn v-else color="#ffe500" :width="($vuetify.breakpoint.xsOnly) ? 280 : 320" light
                            @click="goToMercadoPago" :loading="loading"
                            class=" pa-5 mb-5 elevation-2 font-weight-bold text-caption ">
                            <MercadoPago />
                            Pagar con Mercado Pago
                        </v-btn>
                        <v-btn class="pa-5 font-weight-bold" :width="($vuetify.breakpoint.xsOnly) ? 280 : 320" outlined
                            color="secondary" @click="confirmAndClose(true)">CERRAR</v-btn>
                    </div>
                    <div v-else>
                        <v-card-text v-if="hayOrdenPagoActiva">
                            <v-alert color="orange darken-3" icon="mdi-alert-outline" dark elevation="0" dense
                                class="px-5 my-0 rounded-0 font-weight-regular text-body-1"
                                style="word-break: keep-all;">
                                <div class="font-weight-regular text-body-1">
                                    {{ mensajeError }}
                                </div>
                            </v-alert>
                        </v-card-text>
                        <div class="d-flex flex-column align-center justify-center">
                            <v-btn class="pa-5 mb-5 elevation-0 font-weight-bold" @click="consultarPago"
                                :width="($vuetify.breakpoint.xsOnly) ? '200' : '320'" :loading="loadEspera"
                                :disabled="loadEspera" color="primary">Volver</v-btn>
                            <!--                             <v-btn class="pa-5 elevation-0 font-weight-bold" color="secondary" outlined
                                :loading="loadCancela" :disabled="loadCancela" @click="cancelarOrdenAct"
                                :width="($vuetify.breakpoint.xsOnly) ? '200' : '320'">
                                VOLVER AL SITIO
                            </v-btn> -->
                        </div>
                        <v-spacer></v-spacer>
                        <div class="align-center text-caption-md text-center black--text mt-9">
                            ¿Tenés problemas con el pago?
                            <v-btn text @click="goToContacto" class="ma-0 pa-1 font-weight-bold" small color="primary">
                                Contactanos
                            </v-btn>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import MercadoPago from '@/assets/icons/mercado-pago.vue'
export default {
    name: 'DialogoMercadoPago',

    components: {
        MercadoPago
    },

    data() {
        return {
            isActive: false,
            callback: null,
            esperaPago: false,
            loading: false,
            loadEspera: false,
            loadCancela: false,
        }
    },
    props: {
        titulo: {
            String,
            default: 'Orden de pago'
        },
        orden: {
            type: Object,
            required: true
        },
        origen: {
            type: String,
            default: 'desktop'
        }
    },

    watch: {
        urlMercadoPago(newUrl, url) {
            if (newUrl !== url) this.reloadIframe(newUrl)
        },
    },

    mounted() {
        document.addEventListener('visibilitychange', this.onVisibilityChange)
    },

    beforeDestroy() {
        document.removeEventListener('visibilitychange', this.onVisibilityChange)
    },

    computed: {
        // ...mapGetters('notificaciones', ['loading']),
        ...mapGetters('boletas', ['ordenPago', 'url', 'hayOrdenPagoActiva', 'mensajeError']),
        urlMercadoPago() {
            if (this.ordenPago && typeof this.ordenPago === 'object' && !Array.isArray(this.ordenPago) && Object.keys(this.ordenPago).length > 0) {
                return this.url
            }
            else return this.url
        },

        mensaje() {
            if (!this.esperaPago) {
                // Devuelve MERCADO PAGO en negrita usando v-html
                return 'Vas a ser redirigido a <b>MERCADO PAGO</b> para completar el pago.'
            } else {
                return 'Esperando pago...'
            }
        },
        fuenteOrigen() {
            return this.$device.isMobile ? 'mobile' : 'desktop';
            //return 'mobile';
        },
        esIOS() {
            // Detección robusta de iOS (iPhone, iPod, iPad). Tres casos:
            //   1. UA clasico de iPhone/iPod/iPad.
            //   2. iPad con iOS 13+: el UA es "Macintosh" pero hay multitouch
            //      (maxTouchPoints > 1) que un Mac real no tiene.
            //   3. Fallback al plugin $device si existe (defensa por si en el
            //      futuro cambian los UAs de Apple).
            const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || ''
            const maxTouchPoints = (typeof navigator !== 'undefined' && navigator.maxTouchPoints) || 0
            const isIPhoneIPodIPad = /iPad|iPhone|iPod/.test(ua) && !window.MSStream
            const isIPadDesktopUA = /Macintosh/.test(ua) && maxTouchPoints > 1
            const devicePlugin = this.$device && (this.$device.iphone || this.$device.ios || this.$device.ipad)
            return isIPhoneIPodIPad || isIPadDesktopUA || Boolean(devicePlugin)
        }
    },
    methods: {
        ...mapActions('boletas', ['generarOrder', 'consultarOrdenActiva', 'caducarOrdenPago']),
        ...mapActions('notificaciones', ['showSnack']),
        onIframeLoad() {
            const iframe = this.$refs.mpiframe
            try {
                const url = iframe.contentWindow.location.href;
                if (url.includes("/checkOutMercadoPago")) {
                    this.$emit('returnDialogoMP', url)
                }
            } catch (error) {
                console.log('Error al acceder al contenido del iframe:', error);
            }
        },
        async cancelarOrdenAct() {
            this.loadCancela = true
            this.consultarOrdenActiva().then(() => {
            }).catch(() => {
            }).finally(() => {
                this.confirmAndClose(false)
                this.loadCancela = false
            })
        },

        confirmAndClose(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null;
            }
            this.isActive = false
        },
        consultarPago() {
            this.loadEspera = true
            this.consultarOrdenActiva().then(() => {
            }).catch(() => {
            }).finally(() => {
                this.loadEspera = false
                this.confirmAndClose(false)
            });
        },

        abrirDialogo() {
            this.isActive = true;
            return new Promise(resolve => {
                this.callback = resolve;
                this.$nextTick(() => {
                    if (!this.orden || Object.keys(this.orden).length === 0) {
                        this.confirmAndClose(false)
                        return;
                    }
                    if (this.origen == 'desktop' || this.esIOS) {
                        this.generarOrder(this.orden)
                    }
                });
            });
        },
        onVisibilityChange() {
            // Cuando el usuario abandona la pestaña (iOS abre la app de MP),
            // el modal queda en "esperando pago" al volver.
            if (document.hidden && this.esIOS && this.isActive && !this.esperaPago && this.urlMercadoPago) {
                this.esperaPago = true;
            }
        },
        reloadIframe(url) {
            const iframe = this.$el.querySelector('iframe')
            if (iframe) {
                iframe.src = url
            }

        },
        async goToMercadoPago() {
            this.loading = true;
            try {
                const result = await this.generarOrder(this.orden);
                if (result) {
                    window.open(this.urlMercadoPago, '_blank');
                    this.esperaPago = true;
                } else {
                    this.confirmAndClose(true);
                }
            } catch (error) {
                this.confirmAndClose(true);
            } finally {
                this.loading = false;
            }
        },
        goToContacto() {
            this.$router.push({ name: 'MediosDeContacto' })
            this.confirmAndClose(false)
        }
    }
}

</script>

<style scoped>
/* Look del v-btn de MP pero con anchor HTML puro para preservar el
   Universal Link de iOS. v-btn agrega listeners JS que rompen la apertura
   de la app nativa de MercadoPago en Safari. */
.boton-mp-ios {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #ffe500;
    color: rgba(0, 0, 0, 0.87);
    padding: 20px;
    border-radius: 4px;
    text-decoration: none;
    font-weight: 700;
    font-size: 0.75rem;
    line-height: 1;
    letter-spacing: 0.0892857143em;
    text-transform: uppercase;
    cursor: pointer;
    transition: opacity 0.2s;
}
.boton-mp-ios:hover {
    opacity: 0.85;
}
.boton-mp-ios--disabled {
    pointer-events: none;
    opacity: 0.5;
}
</style>